/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class OverviewRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');

    return hash({
      group,
      // Load all subjects, categories, subcategories, and goals into the model
      subjects: store.findAll('goals/subject'),
      categories: store.findAll('goals/category'),
      subcategories: store.findAll('goals/subcategory'),
      goals: store.findAll('goals/goal'),
      // Load the specific goal based on `goal_id`
      currentGoal: store.findRecord('goals/goal', params.goal_id),
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    // Set the active tab.
    this.controllerFor('group.topics.topic').set('topicTab', 'overview');
  }
}
